module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/onwbKT/tc-custom/9781504073318.jpg?1737640606278",
      "alt": "This image is the cover for the book Hostile, The Tom Hunter Books"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Hostile, The Tom Hunter Books\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("An action-packed tale of shady business, international crime, and an antiviral wonder drug in the series Lee Child called “hard, fast, and really good.”")]), _c('br'), _vm._v(" "), _c('br'), _vm._v(" A young financial executive has uncovered his new boss’s plan to steal the patents to a new breakthrough drug—but before he can undermine the scheme, he is kidnapped."), _c('br'), _vm._v(" "), _c('br'), _vm._v(" The notoriously dangerous Chinese businessman will stop at nothing, including abduction and government corruption, to achieve his goal—and enlists a violent Triad gang to wreak mayhem on those who stand in his way. Now kidnap-rescue operative Tom Hunter is thrown into a deadly race against time to save lives and halt the deadly deal . . .\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Ted Denton\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Bloodhound Books\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5c3ee598","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0